import { render, staticRenderFns } from "./SIconAviso.vue?vue&type=template&id=dfcb52fc"
import script from "./SIconAviso.vue?vue&type=script&lang=js"
export * from "./SIconAviso.vue?vue&type=script&lang=js"
import style0 from "./SIconAviso.vue?vue&type=style&index=0&id=dfcb52fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports